module.exports = __webpack_public_path__ + "media/app/img/audio-editing_2-ced09241b4c4c97b622a19cc93145d86.png";